import api from '@/modules/staff/api';
import isEmpty from 'lodash/isEmpty';

export default {
  namespaced: true,
  state: {
    personalDictionary: null,
    manualError: null,
  },
  actions: {
    SET_MANUAL_ERROR({ commit }, errorUuid) {
      commit('SET_MANUAL_ERROR', errorUuid);
    },
    async GET_DICTIONARY({ commit }) {
      const response = await api.getPersonalDictionary();
      commit('SET_PERSONAL_DICTIONARY', response ? response.words : null);
    },
    async UPDATE_DICTIONARY({ commit, state }, words) {
      const response = await api.updatePersonalDictionary(words);
      commit('SET_PERSONAL_DICTIONARY', response ? response.words : null);
    },
  },
  mutations: {
    SET_PERSONAL_DICTIONARY: (state, dictionary) => {
      state.personalDictionary = dictionary || [];
    },
    SET_MANUAL_ERROR: (state, errorUuid) => {
      state.manualError = errorUuid;
    },
  },
  getters: {
    personalDictionary: state => state.personalDictionary,
    manualError: state => state.manualError,
    preferences: (state, getters, rootState) => rootState.config.staffPreferences,
    homepage: (state, getters) => (isEmpty(getters.preferences.homepage) ? null : getters.preferences.homepage),
  },
};
